import script from "./AddUpdateQType.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdateQType.vue?vue&type=script&setup=true&lang=js"

export default script